const ethData = {
  testnet: {
    chainId: '0xaa36a7',
    chainName: 'Sepolia',
    nativeCurrency: {
      name: 'SepoliaETH',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://ethereum-sepolia.blockpi.network/v1/rpc/public'],
  },
  mainnet: {
    chainId: '0x1',
    chainName: 'Ethereum',
    nativeCurrency: {
      name: 'Ethereum',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://ethereum.blockpi.network/v1/rpc/public'],
  },
}

const bscData = {
  testnet: {
    chainId: '0x61',
    chainName: 'BSC Testnet',
    nativeCurrency: {
      name: 'tBNB',
      symbol: 'tBNB',
      decimals: 18,
    },
    rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545'],
  },
  mainnet: {
    chainId: '0x38',
    chainName: 'BNB Smart Chain (previously Binance Smart Chain Mainnet)',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    rpcUrls: ['https://bsc-dataseed.binance.org/'],
  },
}

const polygonData = {
  testnet: {
    chainId: '0x13881',
    chainName: 'Matic(Polygon) Testnet Mumbai',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    rpcUrls: ['https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78'],
  },
  mainnet: {
    chainId: '0x89',
    chainName: 'Matic(Polygon) Mainnet',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    rpcUrls: ['https://polygon-mainnet.infura.io'],
  },
}

export type evmNetworksDataType = {
  BNB: any
  ETHEREUM: any
  POLYGON: any
  MULTIVERSX: any
}

export const evmNetworksData: evmNetworksDataType = {
  BNB: bscData,
  ETHEREUM: ethData,
  POLYGON: polygonData,
  MULTIVERSX: { testnet: null, mainnet: null },
}

export type evmDataType = {
  bnb: any
  ethereum: any
  polygon: any
  multiversx: any
}

export const evmData: evmDataType = {
  bnb: bscData,
  ethereum: ethData,
  polygon: polygonData,
  multiversx: { testnet: null, mainnet: null },
}
